import { Injectable, } from '@angular/core';
import { Http, Headers } from '@angular/http';
//import {Observable} from 'rxjs/Rx';
//import 'rxjs/add/operator/map'

//  Services
import { StorageService } from './storage.service';
import { HttpService } from './http.service';
import { ServiceFinder } from './finder.service';

//  Libraries
declare var $: any;
import * as moment from 'moment';

@Injectable()
export abstract class AmssService {
    protected apiUrl: string;
    protected year: Number;
    protected symposium: any;
    private http: Http;
    private storageService: StorageService;
    private httpService: HttpService;

    constructor() {
        this.storageService = ServiceFinder.injector.get(StorageService);
        this.httpService = ServiceFinder.injector.get(HttpService);

        this.apiUrl = this.storageService.retrieve('amssApiUrl');
        this.year = this.storageService.retrieve('year');
        this.symposium = this.storageService.retrieve('symposium');
    }

    protected getHttpService():HttpService {
        return this.httpService;
    }

    protected handleError(error: any) {
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/amss.service.ts